import { IGroup } from '@fluentui/react';
import { GroupByOption } from '../../../types';
import { map } from 'lodash';
import { applyGroupNameToGroup } from './applyGroupNameToGroup';

/**
 * Takes a list of groups and applies the "group name" to each group.
 * This is partially a hack to force DetailsList to let us render
 * React components in the group header (to support links).
 */
export const applyGroupNamesToGroupList = (
  groupList: IGroup[],
  groupByOption: GroupByOption
): IGroup[] =>
  map(groupList, group => applyGroupNameToGroup(group, groupByOption));
